import { useContext, useEffect } from 'react';

import { useUserPrint } from '@app/hooks';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';
import { useGetSendoutKeywordsQuery } from '@app/services/rtkQuery/Sendouts/api';

export const useExtendedMessageEffects = () => {
  const { showNotification } = useContext(NotificationContext);

  const { activeBranchId } = useUserPrint();

  const {
    data: sendoutKeywords,
    error,
    isLoading: isKeywordsLoading,
  } = useGetSendoutKeywordsQuery(
    {
      ActiveBranchId: activeBranchId,
    },
    {
      skip: !activeBranchId,
    }
  );

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return {
    isKeywordsLoading,
    sendoutKeywords,
  };
};
